import React, { useState, useEffect } from "react";
import {
  FormControl,
  Box,
  InputLabel,
  Select,
  Button,
  MenuItem,
  Typography,
  FormControlLabel,
  Collapse,
  Chip,
  FormLabel,
  RadioGroup,
  Radio,
  Tooltip,
  Slider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import UserTeamPicker from "../../required-reading/UserTeamPicker";
import DocumentAutosuggest from "../../document/DocumentAutosuggest";
import { reportClient } from "../../../AxiosClient";
import { useTranslation } from "react-i18next";
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import CardList from "../../../core-elements/CardList";
import ItemRequiredReadingDocument from "../../list-item/ItemRequiredReadingDocument";
import FilterWrapper from "../../filter/FilterWrapper";

const useStyles = makeStyles((theme) => ({
  filterDiv: {
    marginTop: 15,
  },
  formControl: {
    display: "flex",
    flex: "1 1 100%",
    margin: theme.spacing(1),
  },
  sliderControl: {
    display: "flex",
    flex: "1 1 50%",
    margin: theme.spacing(6),
    marginBottom: theme.spacing(2),
  },
}));

function InternalFilters(props) {
  const [statsFor, setStatsFor] = useState("users");
  const [allUsers, setAllUsers] = useState(true);
  const [allDocuments, setAllDocuments] = useState(true);
  const [users, setUsers] = useState([]);
  const [documents, setDocuments] = useState([]);
  const classes = useStyles();
  const [sortColumn, setSortColumn] = useState("userLogin");
  const [sortColumns, setSortColumns] = useState([]);
  const [sortDirection, setSortDirection] = useState("asc");
  const [userSortColumns, setUserSortColumns] = useState([]);
  const [documentSortColumns, setDocumentSortColumns] = useState([]);
  const [topicSortColumns, setTopicSortColumns] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [dateRangeValue, setDateRangeValue] = useState(7);
  const [dateRangeUnits, setDateRangeUnits] = useState("day");
  const [dateRangeQualifier, setDateRangeQualifier] = useState("current");
  const [filters, setFilters] = useState({
    sort: "createdDate",
    sortDirection: "DESC",
    draft: "Live",
    titleContains: "",
    favourited: false,
    liked: false,
    viewed: false,
    modifiedSinceLastSeen: false,
    onlyCreatedRecently: false,
    modifiedInLast: 0,
    taxonomyDialogOpen: false,
    createdBy: [],
    modifiedBy: [],
    taxonomy: [],
    createdStart: "",
    createdEnd: "",
    modifiedStart: "",
    modifiedEnd: "",
    loadingUsers: false,
  });
  const daymarks = [
    {
      value: 1,
      label: "1 day",
    },
    {
      value: 2,
      label: "2",
    },
    {
      value: 3,
      label: "3",
    },
    {
      value: 4,
      label: "4",
    },
    {
      value: 5,
      label: "5",
    },
    {
      value: 6,
      label: "6",
    },
    {
      value: 7,
      label: "7",
    },
    {
      value: 8,
      label: "8",
    },
    {
      value: 9,
      label: "9",
    },
    {
      value: 10,
      label: "10 days",
    },
  ];
  const weekmarks = [
    {
      value: 1,
      label: "1 week",
    },
    {
      value: 2,
      label: "2",
    },
    {
      value: 3,
      label: "3",
    },
    {
      value: 4,
      label: "4",
    },
    {
      value: 5,
      label: "5",
    },
    {
      value: 6,
      label: "6",
    },
    {
      value: 7,
      label: "7",
    },
    {
      value: 8,
      label: "8 weeks",
    },
  ];
  const monthmarks = [
    {
      value: 1,
      label: "1 month",
    },
    {
      value: 3,
      label: "3",
    },
    {
      value: 6,
      label: "6",
    },
    {
      value: 9,
      label: "9 months",
    },
  ];
  const yearmarks = [
    {
      value: 1,
      label: "1 year",
    },
    {
      value: 2,
      label: "2",
    },
    {
      value: 3,
      label: "3 years",
    },
  ];
  function valuetext(value) {
    return `${value} ${dateRangeUnits}`;
  }
  const sortDescSVG = "M3,13H15V11H3M3,6V8H21V6M3,18H9V16H3V18Z";
  const sortAscSVG = "M3 11H15V13H3M3 18V16H21V18M3 6H9V8H3Z";
  const { t } = useTranslation();
  useEffect(() => {
    reportClient.get("/sortcolumns/user/").then((res) => {
      setUserSortColumns(res.data);
      statsFor === "users" && setSortColumns(res.data);
    });
  }, []);

  useEffect(() => {
    reportClient.get("/sortcolumns/document/").then((res) => {
      setDocumentSortColumns(res.data);
      statsFor === "documents" && setSortColumns(res.data);
    });
  }, []);

  useEffect(() => {
    reportClient.get("/sortcolumns/topic/").then((res) => {
      setTopicSortColumns(res.data);
      statsFor === "topics" && setSortColumns(res.data);
    });
  }, []);

  useEffect(
    () => {
      processQuery();
    },
    [
      statsFor,
      allUsers,
      allDocuments,
      users,
      documents,
      sortColumn,
      sortDirection,
      startDate,
      endDate,
      dateRangeUnits,
      dateRangeValue,
      dateRangeQualifier,
    ]
  );

  const onFilterChange = (filter) => {
    if (filter.hasOwnProperty("taxonomy") === true) {
      if (
        filter.taxonomy.filter(
          (ele) => ele.type === "taxonomy" && ele.parentList.length === 0
        ).length > 0
      ) {
        filter.taxonomy = [];
      }
    }
    setFilters(filter);
  };

  const processQuery = () => {
    let query = "";
    let userList = [];
    let documentList = [];
    let topicList = [];
    let userSort = { sortColumn: sortColumn, sortDirection: sortDirection };
    let documentSort = { sortColumn: sortColumn, sortDirection: sortDirection };
    let topicSort = { sortColumn: sortColumn, sortDirection: sortDirection };
    // let dateRange = { startDate: new Date(moment().subtract(dateRangeValue,dateRangeUnits)).getTime(), endDate: endDate ? endDate : new Date().getTime()}
    let dateRange = {
      units: dateRangeUnits,
      qualifier: dateRangeQualifier,
    };
    if (statsFor === "users") {
      if (!allUsers && users.length > 0) {
        userList = users;
      }
      query = `
        query GetUserStats($userList:[ID!],$userSort:UserSort,$dateRange:ReportDateRange) {
          getUserStats(id: $userList, userSort: $userSort, dateRange: $dateRange) {
            userId
            userLogin
            firstName
            surname
            numViews
            numLikes
            numFavourites
            numPublishes
            numAuthoredBy
            numRevisedBy
            numSearches
            numReviews
            numApprovals
            numReworks
            numDiscussionEntries
          }
        }
      `;
    } else if (statsFor === "documents") {
      if (!allDocuments && documents.length > 0) {
        documentList = documents.map((d) => d.documentID);
      }
      query = `
        query GetDocumentStats($documentList:[ID!],$documentSort:DocumentSort,$dateRange:ReportDateRange) {
          getDocumentStats(id: $documentList, documentSort: $documentSort, dateRange: $dateRange) {
            title
            documentId
            topicName
            knowledgeSourceName
            knowledgeSourceId
            numViews
            numLikes
            numFavourites
          }
        }
      `;
    } else {
      query = `
        query GetTopicStats($topicList:[ID!],$topicSort:TopicSort,$dateRange:ReportDateRange) {
          getTopicStats(id: $topicList, topicSort: $topicSort, dateRange: $dateRange) {
            topicId
            topicName
            numViews
            numLikes
            numFavourites
            numDocuments
          }
        }
      `;
    }
    props.onFilterChange({
      query,
      variables:
        statsFor === "users"
          ? { userList, userSort, dateRange }
          : statsFor === "documents"
            ? { documentList, documentSort, dateRange }
            : { topicList, topicSort, dateRange },
    });
  };

  const handleRadioChange = (event) => {
    if (event.target.value === "all") {
      setAllUsers(true);
    } else {
      setAllUsers(false);
    }
  };
  const handleDocumentRadioChange = (event) => {
    if (event.target.value === "all") {
      setAllDocuments(true);
    } else {
      setAllDocuments(false);
    }
  };

  const onDocumentSelected = (doc) => {
    if (documents.filter((d) => d.documentID === doc.documentID).length === 0) {
      setDocuments([...documents, doc]);
    } else {
      setDocuments(documents.filter((d) => d.documentID !== doc.documentID));
    }
  };

  const onUsersUpdate = (newUsers) => {
    setUsers([...newUsers.map((u) => u.userId)]);
  };

  const onTeamUsersUpdate = (newUsers) => {
    setUsers([...users, ...newUsers]);
  };

  return (
    <div>
      <div>
        <FormControl className={classes.formControl}>
          <InputLabel>{t("report_choose_data_feed")}</InputLabel>
          <Select
            MenuProps={{
              style: { zIndex: 1310 },
            }}
            id="report-data-feed"
            value={statsFor}
            onChange={(e) => {
              setStatsFor(e.target.value);
              setSortColumns(
                e.target.value === "users"
                  ? userSortColumns
                  : e.target.value === "documents"
                    ? documentSortColumns
                    : topicSortColumns
              );
              setSortColumn(
                e.target.value === "users"
                  ? "userLogin"
                  : e.target.value === "documents"
                    ? "title"
                    : "topicName"
              );
            }}
            inputProps={{
              name: "statsFor",
              id: "statsFor",
            }}
          >
            <MenuItem key="fontSize" value={"users"}>
              {t("report_user_summary_stats")}
            </MenuItem>
            <MenuItem key="fontSize" value={"documents"}>
              {t("report_document_summary_stats")}
            </MenuItem>
            <MenuItem key="fontSize" value={"topics"}>
              {t("report_topic_summary_stats")}
            </MenuItem>
          </Select>
        </FormControl>
      </div>
      <div>
        <Box display="flex" alignItems="center">
          <FormControl className={classes.formControl}>
            <InputLabel>{t("report_sort_column")}</InputLabel>
            <Select
              MenuProps={{
                style: { zIndex: 1310 },
              }}
              value={sortColumn}
              onChange={(e) => setSortColumn(e.target.value)}
              inputProps={{
                name: "sortColumn",
                id: "sortColumn",
              }}
            >
              {sortColumns.map((column, idx) => {
                return (
                  <MenuItem key={idx + "-sortcol"} value={column}>
                    {t("report_column_" + column)}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <Box>
            <Button
              id="sort-direction"
              onClick={(e) =>
                sortDirection === "asc"
                  ? setSortDirection("desc")
                  : setSortDirection("asc")
              }
            >
              <Tooltip
                title={
                  sortDirection === "asc"
                    ? t("global_ascending")
                    : t("global_descending")
                }
              >
                <svg height="24px" width="24px">
                  <path
                    fill={"black"}
                    d={sortDirection === "asc" ? sortAscSVG : sortDescSVG}
                  />
                </svg>
              </Tooltip>
            </Button>
          </Box>
        </Box>
      </div>
      <div>
        <FormControl className={classes.formControl}>
          <FormLabel component="legend">{t("global_date_range")}</FormLabel>
          <RadioGroup
            row
            aria-label="Date range current or previous"
            id="date-range-qualifier"
            value={dateRangeQualifier}
            onChange={(e) => {
              setDateRangeQualifier(e.target.value);
            }}
          >
            <FormControlLabel
              value="current"
              control={<Radio />}
              label={t("global_current")}
            />
            <FormControlLabel
              value="previous"
              control={<Radio />}
              label={t("global_previous")}
            />
          </RadioGroup>
          <RadioGroup
            row
            aria-label="Date range selector"
            id="date-range-units"
            value={dateRangeUnits}
            onChange={(e) => {
              setDateRangeUnits(e.target.value);
              // setDateRangeValue(e.target.value === 'day' ? 7 : e.target.value === 'week' ? 2 : e.target.value === 'month' ? 2 : 1)
            }}
          >
            <FormControlLabel
              value="day"
              control={<Radio />}
              label={t("global_day")}
            />
            <FormControlLabel
              value="week"
              control={<Radio />}
              label={t("global_week")}
            />
            <FormControlLabel
              value="month"
              control={<Radio />}
              label={t("global_month")}
            />
            <FormControlLabel
              value="year"
              control={<Radio />}
              label={t("global_year")}
            />
          </RadioGroup>
        </FormControl>
      </div>
      <Collapse in={statsFor === "users"}>
        <div className={classes.filterDiv}>
          <FormControl className={classes.formControl}>
            <FormLabel component="legend">
              {t("report_show_stats_for")}
            </FormLabel>
            <RadioGroup
              row
              aria-label="All or specific users and teams"
              id="users-or-teams"
              value={allUsers ? "all" : "specific"}
              onChange={handleRadioChange}
            >
              <FormControlLabel
                value="all"
                control={<Radio />}
                label={t("report_all_users")}
              />
              <FormControlLabel
                value="specific"
                control={<Radio />}
                label={t("report_specific_users_or_team")}
              />
            </RadioGroup>
          </FormControl>
          <Collapse in={!allUsers}>
            <Typography>{t("report_selected_users")}</Typography>
            <UserTeamPicker
              onTeamUsersUpdate={onTeamUsersUpdate}
              onUsersUpdate={onUsersUpdate}
              userHeaderKey="create_message_users_header"
              userTeamHeaderKey="create_message_users_team_header"
              asChips
            />
          </Collapse>
        </div>
      </Collapse>
      <Collapse in={statsFor === "documents"}>
        <div>
          <FormControl className={classes.formControl}>
            <FormLabel component="legend">
              {t("report_show_stats_for")}
            </FormLabel>
            <RadioGroup
              row
              aria-label="All or specific documents"
              id="all-or-specific-documents"
              value={allDocuments ? "all" : "specific"}
              onChange={handleDocumentRadioChange}
            >
              <FormControlLabel
                value="all"
                control={<Radio />}
                label={t("report_all_documents")}
              />
              <FormControlLabel
                value="specific"
                control={<Radio />}
                label={t("report_specific_documents")}
              />
            </RadioGroup>
          </FormControl>
          <Collapse in={!allDocuments}>
            <Typography style={{ marginBottom: 10 }}>
              {t("report_show_stats_for_documents")}
            </Typography>
            <div className={classes.infoContainer}>
              <FilterWrapper
                asPopper={false}
                open={true}
                filterElement={"FilterDocuments"}
                filter={filters}
                onFilterChange={onFilterChange}
                isFilterBar={false}
                disabledFilters={["draft"]}
              />
              <div
                style={{ height: 300, marginBottom: 10 }}
                id="report-document-list"
              >
                {!allDocuments && (
                  <CardList
                    parameters={filters}
                    listItem={ItemRequiredReadingDocument}
                    isPortlet={false}
                    selectedDocuments={documents}
                    listOnly
                    onItemClick={onDocumentSelected}
                    portlet={{ id: Math.floor(Math.random() * 1000) + 1 }}
                    listItemTitleColumn={{
                      name: "title",
                      message: "global_document_title",
                    }}
                    messageType="com.kpsol.api.apicommon.document.DocumentInterface"
                  />
                )}
              </div>
            </div>
          </Collapse>
        </div>
      </Collapse>
    </div>
  );
}

export default InternalFilters;
